<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <div class="content_container" fxLayout="row">
    <div class="filter_container" [ngClass]="{ collapse_filter_panel: filterOpen === false }">
      <div
        *ngIf="!filterOpen"
        style="height: 100%; cursor: pointer"
        fxLayoutAlign="start center"
        fxLayout="column"
        (click)="filterOpen = !filterOpen"
      >
        <fa-icon
          class="icon"
          style="font-size: 14px; margin: 20px 0px"
          [icon]="faChevronDoubleRight"
        ></fa-icon>
        <span
          class="filter_text"
          style="transform: rotate(180deg); writing-mode: vertical-rl"
          i18n="title on collapsed filter panel@@filterUpperCase"
          >FILTER</span
        >
      </div>

      <div
        class="filter_container"
        *ngIf="filterOpen"
        fxLayoutAlign="start stretch"
        fxLayout="column"
      >
        <div class="filter_header" fxLayout="row" fxLayoutAlign="start center">
          <fa-icon class="icon" [icon]="faSlidersH"></fa-icon>
          <span class="filter_text" i18n="title in expanded filter panel@@filterPanelHeader"
            >Filter Options</span
          >
          <div class="expand"></div>
          <button mat-icon-button (click)="filterOpen = !filterOpen">
            <fa-icon class="icon" [icon]="faTimes"></fa-icon>
          </button>
        </div>
        <div
          id="filter_scroll_container"
          class="filter_scroll_container"
          fxLayoutAlign="start stretch"
          fxLayout="column"
        >
          <div class="filter_field" fxLayout="row">
            <mat-form-field class="date_picker" appearance="outline">
              <mat-label i18n="label for Execution Started After date picker@@executionStartedAfter"
                >Execution Started After</mat-label
              >
              <input
                [max]="today"
                matInput
                readonly
                [matDatepicker]="fromDatepicker"
                type="text"
                [(ngModel)]="filter.fromDate"
                (dateChange)="filterDropdowns()"
              />
              <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #fromDatepicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="time_picker" appearance="outline">
              <input
                matInput
                readonly
                [ngxTimepicker]="fromTimepicker"
                [format]="24"
                type="text"
                [(ngModel)]="filter.fromTime"
              />
              <ngx-material-timepicker
                #fromTimepicker
                (closed)="filterDropdowns()"
                [format]="24"
              ></ngx-material-timepicker>
            </mat-form-field>
          </div>

          <div class="filter_field" fxLayout="row">
            <mat-form-field class="date_picker" appearance="outline">
              <mat-label
                i18n="label for Execution Started After date picker@@executionStartedBefore"
                >Execution Started Before</mat-label
              >
              <input
                [min]="filter.fromDate"
                [max]="today"
                matInput
                readonly
                [matDatepicker]="toDatepicker"
                type="text"
                [(ngModel)]="filter.toDate"
                (dateChange)="filterDropdowns()"
              />
              <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #toDatepicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="time_picker" appearance="outline">
              <input
                matInput
                readonly
                [ngxTimepicker]="toTimepicker"
                [format]="24"
                type="text"
                [(ngModel)]="filter.toTime"
              />
              <ngx-material-timepicker
                #toTimepicker
                (closed)="filterDropdowns()"
              ></ngx-material-timepicker>
            </mat-form-field>
          </div>

          <mat-form-field class="filter_field" appearance="outline">
            <mat-label i18n="label for workflow dropdown field@@workflowDropDown"
              >Workflow</mat-label
            >
            <mat-select [(ngModel)]="filter.workflowId" (selectionChange)="filterEmployees()">
              <mat-option *ngFor="let workflow of filteredWorkflows" [value]="workflow._id">
                {{ workflow.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="filter_field" appearance="outline">
            <mat-label i18n="label for executedBy dropdown field@@executedByDropDown"
              >Executed by</mat-label
            >
            <mat-select [(ngModel)]="filter.employeeId" (selectionChange)="filterTasks()">
              <mat-option [value]="''" i18n="@@all">All</mat-option>
              <mat-option *ngFor="let employee of employees" [value]="employee.employeeId">
                {{ employee.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="filter_field" appearance="outline">
            <mat-label i18n="label for task dropdown field@@taskDropDown">Task</mat-label>
            <mat-select [(ngModel)]="filter.taskId">
              <mat-option [value]="''" i18n="@@all">All</mat-option>

              <mat-option *ngFor="let task of tasks" [value]="task.taskId">
                {{ task.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button
            class="filterButton"
            mat-raised-button
            style="width: 270px; margin-left: 20px !important"
            color="primary"
            (click)="onFilterClicked()"
            i18n="button label@@filter"
          >
            Filter
          </button>
        </div>
      </div>
    </div>
    <div class="dashboard">
      <router-outlet> </router-outlet>
    </div>
  </div>
</div>
